/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Vue from 'vue';
import props from './aside-props.js';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var classPrefixMixins = getClassPrefixMixins("aside");
var _Aside = mixins(Vue, classPrefixMixins).extend({
  name: "TAside",
  props: _objectSpread({}, props),
  data: function data() {
    return {};
  },
  inject: {
    layout: {
      "default": void 0
    }
  },
  mounted: function mounted() {
    this.layout.hasSider = true;
  },
  destroyed: function destroyed() {
    this.layout.hasSider = false;
  },
  render: function render() {
    var h = arguments[0];
    var styles = this.width ? {
      width: this.width
    } : {};
    return h("aside", {
      "class": "".concat(this.classPrefix, "-layout__sider"),
      "style": styles
    }, [renderTNodeJSX(this, "default")]);
  }
});

export { _Aside as default };
//# sourceMappingURL=aside.js.map
